module.exports = __webpack_public_path__ + "static/media/blueMoon.5811660f.jpeg";